import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { SafeResourceUrl } from '@angular/platform-browser';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { KeyValueModel } from '@core/key-value-model';
import { DeviceAppVersionModel, DeviceAppVersionTextField } from '@core/models/device-app-version-model';
import { CommonService } from '@core/service/common/common.service';
import { DeviceAppVersionService } from '@core/service/device-app-version/device-app-version.service';
import { GlobalService } from '@core/service/global.service';
import { UnsubscribeOnDestroyAdapter } from '@shared';
import { BreadcrumbButtonTopComponent } from '@shared/components/breadcrumb-button-top/breadcrumb-button-top.component';
import { BreadcrumbV2Component } from '@shared/components/breadcrumb-v2/breadcrumb-v2.component';
import { ValidatorErrorComponent } from '@shared/components/validator-error/validator-error.component';
import { ImportALlModule } from '@shared/imports';
import { EMPTY_GUID } from '@shared/tools/constants/constants';
import { MenuLink } from '@shared/tools/enums/enum-router';
import { keyValueYesNoList, EnumStatusPublish, EnumAction } from '@shared/tools/enums/enum-status.enum';
import { EnumText } from '@shared/tools/enums/enum-Text';
import { EnumExtensionFile, ExtensionFile } from '@shared/tools/enums/extension-file.enum';
import { PermissionCode } from '@shared/tools/enums/permission';
import { Severity } from '@shared/tools/enums/severities';
import { MessageService, ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MessagesModule } from 'primeng/messages';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';
import { delay } from 'rxjs';

@Component({
  selector: 'app-device-app-version-form',
  standalone: true,
    imports: [
      //BreadcrumbV2Component, ValidatorErrorComponent,
      MessagesModule, ConfirmDialogModule, ToastModule, TabViewModule,TableModule,
      BreadcrumbButtonTopComponent,
      ImportALlModule,
    ],
  templateUrl: './device-app-version-form.component.html',
  styleUrl: './device-app-version-form.component.scss'
})
export class DeviceAppVersionFormComponent  extends UnsubscribeOnDestroyAdapter implements OnInit
{
  public textField=DeviceAppVersionTextField;
  loadingGroupeDataList = false;
  contenuStr = '';

  public bannerOrNoImagePathUrl='./assets/images/no_image_available.png';
  public bannerPath='';
  public isFileBannerSelected=false;

  public objDeviceApp: DeviceAppVersionModel = new DeviceAppVersionModel();
  public keyValueYesNoList = keyValueYesNoList;
  @ViewChild('vcFileBannerSelected', { static: false }) vcFileBannerSelected!: ElementRef;

  constructor(
    public router: Router,
    private fb: FormBuilder,
    public activatedRoute: ActivatedRoute,
    public commonService: CommonService,
    public messageService: MessageService,
    public deviceAppVersionService: DeviceAppVersionService,
    public confirmationService: ConfirmationService,
    public globalService: GlobalService,
  ) {
      super();
      //this.userName = this.commonService.authorizationService.sessionAuthService.userConnected.userName;

  }

  ngOnInit(): void {
    //console.log('ngOnInit:',this.chantUser);
    this.activatedRoute.params.subscribe((params: Params) => {
      this.id = params['id'];
      console.log('Params:',params);
    });
    this.loadAllData();
  }
  get disabledBtnSaveChanges(): boolean{
    return this.formGroupPageName.invalid;
  }
  async loadAllData() {
    this.initForm();
    await this.getPermission();
    await this.getOneById( this.id );
  }
  async getPermission(){
    this.addButton = await this.commonService.authorizationService.hasPermission([PermissionCode.AddPermissions]);
    this.editButton = await this.commonService.authorizationService.hasPermission([PermissionCode.EditPermissions]);
    this.deleteButton = await this.commonService.authorizationService.hasPermission([PermissionCode.DeletePermissions]);
    this.addOrEditButton = this.isNew? this.addButton : this.editButton;
  }

  async getOneById(id: any ){
    let userName = this.commonService.authorizationService.userConnected.userName;
    this.isNew = ( this.id == '' || this.id == EMPTY_GUID );
    this.title = ((this.isNew) ? this.enumText.New : this.enumText.Edit) +' '+ this.textField.title

    if( !this.isNew ){
      this.globalService.showLoader();
      this.subs.sink = await this.deviceAppVersionService.getOne(id).subscribe({
        next:(result)=> {
          this.objDeviceApp = result;
          this.bannerOrNoImagePathUrl = this.objDeviceApp.appLogoPathUrl;
          this.isFileBannerSelected = true;
          //console.log(`groupeCu`,this.groupeCu);
          this.globalService.showLoader(false);
        },
        complete(){},
        error: (ex)=>{
          console.log(`error`, ex);
          this.globalService.showLoader(false);
        }
      });
    }else{
        this.objDeviceApp = new DeviceAppVersionModel();
        // this.objDeviceApp.id = 0;
        // this.objDeviceApp.userId = this.userName;
        // if( !this.isFromAdminCE ){
        //   this.objDeviceApp.groupeChantantId = EnumGroupeChantant.CHANT_INTERNAUTE;
        // }
        //console.log(`NEW chantUser`,this.chantUser);
        //this.groupeCu.code = uuid.v4();
    }
  }

  triggerFileInput(): void {
    // Déclenche un clic sur l'élément input de fichier
    this.vcFileBannerSelected.nativeElement.click();
  }

  onChangePackageName() {
    console.log('packageName', this.objDeviceApp.packageName);
    this.objDeviceApp.applicationId = this.objDeviceApp.packageName;
  }
  onChangeFileUpload(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      let extension = file.type.split('/')[1];
      let extension2 = file.name.split('.').pop()?.toString()??'';
      console.log(`${extension} | ${extension2}`);
      if(!ExtensionFile.CheckImageFile(extension) && !ExtensionFile.CheckImageFile(extension2) ){
        this.messageService.add({severity:Severity.warn, summary: this.textField.title, detail: ` Format required : ${EnumExtensionFile.Extention_ImageFile}`});
        this.isFileBannerSelected = false;
        input.files=null;
        input.value='';
        this.vcFileBannerSelected.nativeElement.value = null;
        return;
      }
      console.log(`extension:${extension} | ${extension2}`, file);
      this.objDeviceApp.extention = extension2.toLowerCase();
      // this.groupeCu.contentType = file.type;
      // this.groupeCu.size = file.size.toString();
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.bannerOrNoImagePathUrl = e.target.result;
        this.bannerPath = e.target.result.split(',').pop()?.toString()
        this.isFileBannerSelected = true;
        this.objDeviceApp.appLogo = this.bannerPath;
        console.log(`this.objDeviceApp.appLogo`, this.objDeviceApp.appLogo);
      };
      reader.readAsDataURL(file);
    } else {
      this.isFileBannerSelected = false;
    }
  }

  onNew(){
    this.globalService.showLoader();
    this.isNew=false;
    this.id = 0;
    this.objDeviceApp=new DeviceAppVersionModel();
    this.router.navigate([ MenuLink.DeviceAppVersion, this.id ]);
    this.globalService.showLoader(false);
  }
  initForm(){
    let formFields: any = {
      packageName: this.fb.control(this.objDeviceApp.packageName, [Validators.required]),
      appName: this.fb.control(this.objDeviceApp.appName, [Validators.required]),
      appLogo: this.fb.control(this.objDeviceApp.appLogo,),
      appLogoPathUrl: this.fb.control(this.objDeviceApp.appLogoPathUrl, ),
      applicationId: this.fb.control(this.objDeviceApp.applicationId, [Validators.required]),
      versionName: this.fb.control(this.objDeviceApp.versionName, [Validators.required]),
      versionCode: this.fb.control(this.objDeviceApp.versionCode, [Validators.required]),
      buildNumber: this.fb.control(this.objDeviceApp.buildNumber, [Validators.required]),

      extention:this.fb.control(this.objDeviceApp.extention ),
      isRequired: this.fb.control(this.objDeviceApp.isRequired, [Validators.required]),
      versionInfo: this.fb.control(this.objDeviceApp.versionInfo, [Validators.required]),
      linkAndroid: this.fb.control(this.objDeviceApp.linkAndroid, [Validators.required]),
      linkApple: this.fb.control(this.objDeviceApp.linkApple, [Validators.required]),
      linkWebSite: this.fb.control(this.objDeviceApp.buildNumber, []),
      bannerOrNoImagePathUrl: this.fb.control(this.objDeviceApp.appLogoPathUrl),
    };
    this.formGroupPageName = this.fb.group(formFields);
  }

  onClose(){
    this.router.navigate([ MenuLink.DeviceAppVersion ]);
  }

  onSubmit(): void {
    console.log('formGroupPageName:', this.formGroupPageName.value);
    //console.log('formGroupPageName.invalid:', this.formGroupPageName.invalid);
    this.clear();
    if (this.formGroupPageName.invalid) {
      return;
    }
    this.globalService.showLoader();
    let obj = this.formGroupPageName.value;


    console.log('formGroupPageName:obj::', obj);
    this.subs.sink = this.deviceAppVersionService.saves(this.isNew, obj ).subscribe({
      next: (result: any) => {
        console.log(`result:`,result);
        if( result ){
          this.messageService.add({severity:Severity.info, summary: this.textField.title, detail: EnumText.sauvegardeEffectuee});
          this.globalService.showLoader(false);
          this.onClose();
        }else{
          this.messageService.add({severity:Severity.error, summary: EnumText.error, detail: EnumText.msg_TraitementImpossible});
        }
      },
      error: (ex: any) => {
        console.log(`ERROR.::.`,ex);
        this.globalService.showLoader(false);
        //this.error = ex;
        this.messageService.add({severity:Severity.error, summary: EnumText.error, detail: EnumText.msg_TraitementImpossible});
      },
      complete: () => {
        //console.log(`COMPLETE.::.`);
         this.globalService.showLoader(false);
      }
    });
  }

  clear() {
      this.messageService.clear();
  }

  onError(error: any){
    console.log(error.message);
  }

}
